module.exports = __webpack_public_path__ + "0533a65cde92304e551742f3fee285a6.svg";